import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloud2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCloud2"><Path d="M10 3.5C11.6974 3.5 13.2294 4.20614 14.3193 5.33691C14.6212 5.27991 14.9324 5.25 15.25 5.25C18.0114 5.25 20.25 7.48858 20.25 10.25C20.25 10.3446 20.2466 10.4383 20.2412 10.5312C21.8763 11.3527 23 13.0435 23 15C23 17.7614 20.7614 20 18 20H7C3.68629 20 1 17.3137 1 14C1 11.7597 2.22759 9.80756 4.04395 8.77734C4.40078 5.80447 6.93058 3.5 10 3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCloud2;
